import Banner from "../../Components/ProductsListing/Banner/Banner";
// import CategoryFilter from "../../Components/ProductsListing/CategoryFilter/CategoryFilter";
import AllProducts from "../../Components/ProductsListing/ProductList/AllProducts/AllProducts";

const Products = () => {
  return (
    <>
      {/* <CategoryFilter /> */}
      <Banner/>
      <AllProducts/>
    </>
  );
};
export default Products;
